import PageHeader from '@components/PageHeader'
import './index.scss'

import useEvents from '@hooks/useEvents'
import LoadingIndicator from '@components/LoadingIndicator'
import ErrorView from '@components/ErrorView'
import { useNavigate } from 'react-router-dom'
import EventCard from './EventCard'

export default function EventsPage() {
  const navigate = useNavigate();
  const { events, loading, error, refetch } = useEvents();

  return <div className='events-page'>
    <PageHeader title='Events' showBackButton={false} links={[
      {
        title: "New Event",
        onClick: () => {
          navigate('/events/create');
        }
      }
    ]} />

    <div className='events-container'>
      {loading ? <LoadingIndicator /> : null}

      {error ? <ErrorView error={error} buttonText="Retry" buttonAction={() => refetch()} /> : null}

      {events && events.length === 0 ? <p className='no-events'>No upcoming events.</p> : null}

      {events && events.length > 0 ? <div className='cards'>
        {events.map((e) => {
          return <EventCard key={e.id}
            title={e.title}
            thumbnailURL={e.thumbnailURL}
            dateInfo={{
              showTimes: e.showTimes,
              startsAt: e.startsAt,
              endsAt: e.endsAt
            }}
            onClick={() => {
              navigate(`/events/${e.id}`);
            }} />
        })}
      </div> : null}
    </div>
  </div>
}
